/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLeadExchangeDestinationsResponseData } from './GetLeadExchangeDestinationsResponseData';
import {
    GetLeadExchangeDestinationsResponseDataFromJSON,
    GetLeadExchangeDestinationsResponseDataFromJSONTyped,
    GetLeadExchangeDestinationsResponseDataToJSON,
    GetLeadExchangeDestinationsResponseDataToJSONTyped,
} from './GetLeadExchangeDestinationsResponseData';

/**
 * 
 * @export
 * @interface GetLeadExchangeDestinationsResponse
 */
export interface GetLeadExchangeDestinationsResponse {
    /**
     * 
     */
    data?: GetLeadExchangeDestinationsResponseData;
}

/**
 * Check if a given object implements the GetLeadExchangeDestinationsResponse interface.
 */
export function instanceOfGetLeadExchangeDestinationsResponse(value: object): value is GetLeadExchangeDestinationsResponse {
    return true;
}

export function GetLeadExchangeDestinationsResponseFromJSON(json: any): GetLeadExchangeDestinationsResponse {
    return GetLeadExchangeDestinationsResponseFromJSONTyped(json, false);
}

export function GetLeadExchangeDestinationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadExchangeDestinationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : GetLeadExchangeDestinationsResponseDataFromJSON(json['data']),
    };
}

export function GetLeadExchangeDestinationsResponseToJSON(json: any): GetLeadExchangeDestinationsResponse {
    return GetLeadExchangeDestinationsResponseToJSONTyped(json, false);
}

export function GetLeadExchangeDestinationsResponseToJSONTyped(value?: GetLeadExchangeDestinationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': GetLeadExchangeDestinationsResponseDataToJSON(value['data']),
    };
}

